var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9467 10.7489H9.42771L9.47877 10.1999C9.50431 9.75308 10.015 9.37006 10.5257 8.8849C11.1002 8.33591 11.662 7.672 11.662 6.67615C11.662 5.00363 10.3853 4.18652 8.95531 4.18652C7.89563 4.18652 6.92531 4.64615 6.33801 5.36112L7.55091 6.47187C7.85732 6.05055 8.34248 5.78244 8.82764 5.78244C9.42771 5.78244 9.83626 6.13992 9.83626 6.77829C9.83626 7.35282 9.42771 7.81244 9.03192 8.24653C8.50846 8.78276 7.93393 9.30622 7.9467 10.1106V10.7489ZM8.7255 13.8131C9.28726 13.8131 9.75966 13.3535 9.75966 12.7789C9.75966 12.2172 9.28726 11.7575 8.7255 11.7575C8.13821 11.7575 7.66581 12.2172 7.66581 12.7789C7.66581 13.3535 8.13821 13.8131 8.7255 13.8131Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionRound);
export default __webpack_public_path__ + "static/media/question-round.f281f08e31b5d6c15dbd2e542d4f0d19.svg";
export { ForwardRef as ReactComponent };